export const PAPER = '#F2EBDC';
export const PAPER_2 = '#EDE5D1';
export const INK = '#1B1814';
export const INK_MID = '#5C5147';
export const INK_SOFT = '#8E8474';
export const LINE = '#D9CFB8';
export const ACCENT = '#A67C3A';
export const GOLD_DEEP = '#7A5820';
export const GOLD_LITE = '#C9A45E';
export const WINE = '#5B2A2E';
